import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
`;

const PlayBtn = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #397ef3;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 8px;

  .anticon svg {
    fill: white;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Duration = styled.p`
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  color: #397ef3;
  font-size: 12px;
  position: absolute;
  top: 12px;
`;

const Input = styled.input`
  height: 1px;
  min-width: 180px;
  cursor: pointer;

  &::-webkit-slider-thumb {
    height: 7px;
    width: 7px;
    border-radius: 7px;
    background: #397ef3;
  }

  &::-moz-range-thumb {
    height: 7px;
    width: 7px;
    border-radius: 7px;
    background: #397ef3;
  }
  &::-ms-thumb {
    height: 7px;
    width: 7px;
    border-radius: 7px;
    background: #397ef3;
  }
`;

const AudioPlayer = ({ path }) => {
  const ref = useRef(null);
  const [position, setPosition] = useState(0);
  const [currentTime, setCurrentTime] = useState('00:00');
  const [duration, setDuration] = useState(0);
  const [isStarted, setIsStarted] = useState(false);

  const play = () => {
    ref.current?.audioEl.current?.play();
    setIsStarted(true);
  };
  const pause = () => ref.current?.audioEl.current?.pause();
  const handleClickPlay = () => (ref.current?.audioEl.current?.paused ? play() : pause());
  const handleChange = (event) => {
    setPosition(event.target.value);
    if (ref.current?.audioEl.current) {
      ref.current.audioEl.current.currentTime = event.target.value;
    }
  };

  useEffect(() => {
    if (ref.current?.audioEl.current) {
      ref.current.audioEl.current.ontimeupdate = () => {
        setPosition(ref.current?.audioEl.current?.currentTime);
        setCurrentTime(
          moment.utc((ref.current?.audioEl.current?.currentTime ?? 0) * 1000).format('mm:ss'),
        );
      };
    }

    return () => {
      if (ref.current?.audioEl.current) {
        ref.current.audioEl.current.ontimeupdate = null;
      }
    };
  }, [ref.current?.audioEl.current]);

  const handleCanPlay = () => {
    setDuration(Math.round(ref.current?.audioEl.current?.duration));
  };

  const durationTime = moment.utc(duration * 1000).format('mm:ss');

  return (
    <Wrapper>
      <ReactAudioPlayer ref={ref} src={path} onCanPlay={handleCanPlay} />
      <PlayBtn onClick={handleClickPlay}>
        {!ref.current?.audioEl.current?.paused ? <PauseOutlined /> : <CaretRightOutlined />}
      </PlayBtn>
      <InputWrapper>
        <Input
          type="range"
          value={position}
          onChange={handleChange}
          max={duration}
          min={0}
          step={1}
        />
        <Duration>{!isStarted ? durationTime : currentTime}</Duration>
      </InputWrapper>
    </Wrapper>
  );
};

export default AudioPlayer;
